
import css from 'styled-jsx/css';

export default css.global`/* @styled-jsx=global */

.addon-pricing {
  &__container {
    padding: 16px;

    > * + * {
      padding-top: 20px;
    }
  }

  &__title {
    text-align: center;
    padding-bottom: 10px;
  }

  &__table {
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr;

    > * {
      padding: 12px 14px;
    }

    &--header {
      color: $white-legacy;
      background-color: $black-legacy;
    }

    &--header,
    &--row {
      display: flex;

      > * {
        width: 50%;
      }

      p {
        font-size: 13px;
        line-height: 18px;
        font-family: Graphik;
        font-weight: normal;
        margin-bottom: 4px;
      }

      h1 {
        font-size: 15px;
        line-height: 27px;
        font-family: Graphik;
        font-weight: normal;
      }
    }

    &--row {
      border-bottom: 1px solid $black-legacy;
    }

    &--row:last-of-type {
      border-bottom: none;
    }
  }
}
`